import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';

import { need4SteelUserGuard } from './guards/need4steel-user.guard';
import { need4SteelWizardEnterGuard } from './guards/need4steel-wizard-enter.guard';
import { need4SteelWizardExitGuard } from './guards/need4steel-wizard-exit.guard';
import { PAGE_NAME_STEPS } from './services/need4steel-wizard.service';
import { NeedSteelComponent } from './components/need-steel.component';
import { StepHeaderComponent } from './components/wizard/step-header/step-header.component';
import { StepSummaryComponent } from './components/wizard/step-summary/step-summary.component';
import { WizardComponent } from './components/wizard/wizard.component';
import { productFieldTranslationGuard } from './guards/product-field-translation.guard';

export const routes: Routes = [
	{
		path: 'offerlist',
		component: NeedSteelComponent,
		canActivate: [need4SteelUserGuard],
		data: { pageName: 'Need4Steel - Offer List', service: SERVICE_ANALYTICS.NEED_FOR_STEEL }
	},
	{
		path: 'wizard',
		component: WizardComponent,
		canDeactivate: [need4SteelWizardExitGuard],
		children: [
			{
				path: '',
				redirectTo: PAGE_NAME_STEPS[0],
				pathMatch: 'full',
				data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.NEED_FOR_STEEL }
			},
			{
				path: PAGE_NAME_STEPS[0],
				component: StepHeaderComponent,
				canActivate: [need4SteelUserGuard, need4SteelWizardEnterGuard, productFieldTranslationGuard],
				// eslint-disable-next-line @stylistic/max-len
				data: { pageName: 'Need4Steel - Wizard Step 1 (Product Selection)', service: SERVICE_ANALYTICS.NEED_FOR_STEEL }
			},
			{
				path: PAGE_NAME_STEPS[1],
				component: StepSummaryComponent,
				canActivate: [need4SteelUserGuard, need4SteelWizardEnterGuard],
				data: { pageName: 'Need4Steel - Wizard Step 2 (Summary)', service: SERVICE_ANALYTICS.NEED_FOR_STEEL }
			}
		]
	}
];
